import { Dialog, DialogContent, DialogTitle, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import Withdrawal from '../Pages/StashKar/Dashboard/Withdrawal';
const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: "flex-end", // push the dialog to bottom

    },
    paper: {
        // make the content full width
        maxWidth:'480px',
        margin: '0 auto',
        // maxWidth: "100%",
        width: "100%",
        height: "150px"
    }
}));

const MessageDialogBox = (props: any) => {
    const classes = useStyles();
    return (
        <Dialog
            open={props.toggle}
            onClose={props.handleClose}
            classes={{ container: classes.root, paper: classes.paper }}
        >
            <DialogTitle style={{ padding: '0' }}>
                <IconButton onClick={props.handleClose} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {props.type === 'calculator' &&
                <DialogContent style={{ textAlign: 'center', margin: '20px 0' }}>Calculator is launching soon to help you calculate your returns</DialogContent>
            }
            {props.type === 'referral' &&
                <DialogContent style={{ textAlign: 'center', margin: '20px 0' }}>Referral program is launching soon!</DialogContent>
            }
            {props.type === 'promoCode' &&
                <DialogContent style={{ textAlign: 'center', margin: '20px 0' }}>Referral program is launching soon1</DialogContent>
            }
            {props.type === 'getNow' &&
                <DialogContent style={{ textAlign: 'center', margin: '20px 0' }}>Launching soon!</DialogContent>
            }

{props.type === 'lender' &&
                <DialogContent style={{ textAlign: 'center', margin: '20px 0' }}>
                    {/* <InnerHTML html={props.lenderResponse}/> */}
                </DialogContent>
            }
        </Dialog>
    );
};

export default MessageDialogBox;
